import React from 'react'

import './Loader.css'

const Loader = ({size = 48}) =>  <div className="Loader" style={{"--size": size+"px" }} />

export default Loader;
